<template>
  <div
       :class="[!form.split ? 'max-w-7xl mx-auto' : 'mx-2', 'max-w-7xl mx-auto p-2 my-2 rounded-lg']"
  >
    <div
         :class="[form.split ? 'grid-cols-2' : 'grid-cols-1', 'grid gap-3']"
    >
        <div class="p-3 bg-gray-50 shadow rounded-lg">
          <div class="capitalize">
            <h1 class="text-xl font-medium">{{ note.type === 'collection' ? 'Collection by Customer' : 'To be Delivered' }}</h1>
          </div>
          <template v-if="!form.split">
            <MasterListItems
              v-model="form.items"
              :items="form.actual.items"
              :note="note"
            />
            <OtherWarehouseItems
              v-if="otherWarehouses.length"
              :warehouses="otherWarehouses"
            />
          </template>
          <template v-else>
            <NoteDetailItems
              v-model="form.actual"
              :key="note.type"
              :type="note.type"
              :warehouses="warehouses"
              @selected="onSelectItem"
              @removed="onRemoveItem"
              :order-id="note.order_id"
              :enabled="form.split"
              :partial="partial"
              :handover-items="form.items"
              :canHandoverItemsToCustomer="canHandoverItemsToCustomer"
            />
          </template>
        </div>
        <div class="p-3 bg-gray-50 shadow rounded-lg" v-if="form.split">
          <div class="capitalize">
            <h1 class="text-xl font-medium" v-if="getSplitType === 'delivery'">{{ getSplitType }}</h1>
            <SelectInput v-else v-model="form.splits.type" @input="onChangeSplitType">
              <option value="collection">Collection by Customer</option>
              <option value="delivery">To be Delivered</option>
            </SelectInput>
          </div>
          <NoteDetailItems
            v-model="form.splits"
            :selected="form.splits.items"
            :key="'split-'+form.splits.type"
            :type="note.type"
            :warehouses="warehouses"
            :order-id="note.order_id"
            @quantity-change="onQuantityChange"
           />
          <div class="mt-3">
            <div v-if="form.splits.type === 'delivery'" class="grid grid-cols-2 gap-3">
              <div :class="{'col-span-full': form.splits.delivery_location !== 'island' }">
                <SelectInput
                  v-model="form.splits.delivery_location"
                  label="Delivery Location"
                  :errors="form.errors['splits.delivery_location']"
                >
                  <option v-for="(label, value) in locations" :value="value">{{ label }}</option>
                </SelectInput>

              </div>
              <div v-if="form.splits.delivery_location === 'island'">
                <SelectInput
                  v-model="form.splits.vessel_location"
                  label="Vessel Location"
                  :errors="form.errors['splits.vessel_location']"
                >
                   <option v-for="location in vesselLocations.island" :value="location">{{ location }}</option>
                </SelectInput>
              </div>
              <div class="col-span-full">
                <template v-if="form.splits.delivery_location !== 'island'">
                  <FormInput
                    type="text"
                    v-model="form.splits.delivery_address"
                    label="Delivery Address"
                    :errors="form.errors['splits.delivery_address']"
                  />
                </template>
                <SelectInput v-else v-model="form.splits.boat_id" label="Vessel" :errors="form.errors['splits.boat_id']">
                  <option v-for="vessel in boats" :value="vessel.id">{{ vessel.name }}</option>
                </SelectInput>
              </div>
            </div>
          </div>
        </div>

      <div class="col-span-full">
        <div class="flex justify-between">
          <div class="flex gap-2">
            <template v-if="!handoverList && note.status !== 'completed' && canAdmin(['update-dispatch-notes'])">
              <button
                v-if="!form.split"
                @click="split"
                class="btn-primary flex gap-x-3 items-center py-2"
                :disabled="partial"
              >
                Split
                <Icon name="code" class="h-5 w-5" />
              </button>
              <button v-else @click="resetSplit" class="btn-primary flex gap-x-3 items-center py-2">
                Cancel Split
                <Icon name="code" class="h-5 w-5" />
              </button>
            </template>
          </div>
          <div v-if="canAdmin('create-dispatch-notes') && form.split" class="flex gap-x-3 items-center">
            <LoadingButton
              :loading="form.processing"
              :disabled="form.processing || !form.splits.items.length"
              @click="makeSplit"
              class="btn-primary"
            >
              Save
            </LoadingButton>
          </div>
          <div v-else class="flex gap-x-2">

            <AssignTeamModal
              v-if="note.type === 'delivery' && (note.status !== 'void' || note.status !== 'completed')"
              v-slot="{open}"
              :key="'row-'+note.id"
              :note="note"
              :items="form.items"
              @closed="resetSelection"
            >
              <button
                class="btn-primary"
                @click="open"
                type="button"
                :disabled="!form.items.length"
              >
                Assign Team
              </button>
            </AssignTeamModal>

            <a :href="route('delivery-notes.print-schedule', {
                      note: note.id,
                      order: note.order_id,
                    })"
               class="btn-primary" target="_blank">
              Print
            </a>
            <a
              :href="route('customer.orders.download-file', {customerOrder: note.order_id, file: 'quotation', preview: 'preview' })"
              class="btn-primary" target="_blank">
              Invoice
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoteDetailItems from "./NoteDetailItems.vue";
import AssignTeamModal from "./AssignTeamModal.vue";
import SelectInput from "@/Shared/SelectInput.vue";
import FormInput from "@/Shared/Form/FormInput.vue";
import LoadingButton from "@/Shared/LoadingButton.vue";
import Icon from "@/Shared/Icon.vue";
import OtherWarehouseItems from "../Dispatch/Partials/OtherWarehouseItems.vue";
import MasterListItems from "./Partials/MasterListItems.vue";

export default {
  name: 'MasterList',
  components: {
    MasterListItems,
    OtherWarehouseItems,
    Icon, LoadingButton, FormInput, SelectInput, AssignTeamModal, NoteDetailItems},

  props: {
    note: Object,
    warehouses: Array,
    locations: Object,
    vessels: Array,
    vesselLocations: Object,
    filters: Object,
    handoverList: Boolean,
    itemsRoute: {
      type: null,
      default: 'ajax.delivery-notes.get-items'
    },
    isAdmin: Boolean,
  },

  data() {
    return {
      partial: false,
      otherWarehouses: [],
      form: this.$inertia.form({
        split: false,
        note_id: this.note.id,
        actual: {
          type: this.note.type,
          items: [],
        },
        splits: {
          type: null,
          delivery_location: null,
          vessel_location: null,
          boat_id: null,
          delivery_address: null,
          items: [],
        },
        items: [],
      }),
      boats: this.vessels || []
    }
  },

  watch: {
    'form.splits.delivery_location': {
      handler(location) {
        if (location === 'island') {
          this.fetchVessels()
        }
      },
      immediate: true
    },
    'form.items': {
      handler(items) {
        this.partial = items.length > 0
      }
    }
  },

  computed: {
    canHandoverItemsToCustomer() {
      return this.canAdmin([
        'update-dispatch-notes',
      ]) && this.note.status === 'in-progress' || this.note.type === 'collection'
    },

    getSplitType() {
      return this.note.type === 'collection' ? 'delivery' : 'collection'
    },
    canIssueItem() {
      let can = false;
      const note = this.note
      if (!this.canAdmin([
        'update-dispatch-notes',
      ])) {
        return false;
      }

      if (Object.keys(note).length) {
        if (note.type === 'delivery' && note.team_id) {
          can = true
        } else if (note.type === 'collection') {
          can = true
        }
      }
      return can
    }
  },

  methods: {
    onChangeSplitType() {
      if (this.form.splits.type === 'collection') {
        this.form.splits.boat_id = null
        this.form.splits.vessel_location = null
      }
    },
    resetSplit() {
      this.form.actual.items.forEach(item => {
        if (item.original_quantity !== undefined) {
          item.quantity_pending = item.original_quantity
        }
      })

      this.$nextTick(() => {
        this.split()
        this.fetchItems()
      })
    },

    split() {
      this.form.split = !this.form.split
      this.form.splits.type = this.getSplitType
      this.form.splits.vessel_location = null
      this.form.splits.delivery_location = null
      this.form.splits.items = []
    },

    makeSplit() {
      if (this.handoverList) return;
      this.form.post(this.route('delivery-notes.split'))
    },

    onQuantityChange(splitItem) {
      let item = this.form.actual.items.find(itm => itm.id === splitItem.id)
      if (item) {
        const quantity = item.original_quantity - splitItem.quantity_splited
        item.quantity_pending = quantity > 0 ? quantity : 0
      }
    },

    onSelectItem(item) {
      if(this.form.split) {
        if (!this.form.splits.items.some(itm => itm.id === item.id)) {
          this.form.splits.items.push(item)
        }
      } else {
        this.partial = true
        if (this.partial) {
          const index = this.form.items.findIndex(val => val.id === item.id);
          if (index !== -1) {
            this.form.items.splice(index, 1);
          } else {
            if (this.form.items.length === 0 || this.form.items[0].warehouse_id === item.warehouse_id) {
              this.form.items.push(item);
            }
          }
        }

      }
    },

    resetSelection() {
      this.form.items = []
      this.partial = false

      this.fetchItems()
    },

    onRemoveItem(item) {
      const index = this.form.splits.items.findIndex(itm => itm.id === item.id)
      const splitItem = this.form.splits.items.find(itm => itm.id === item.id)
      const actualIndex = this.form.actual.items.findIndex(itm => itm.id === item.id)
      if (this.form.splits.items.splice(index, 1)) {
        this.form.actual.items[actualIndex].quantity_pending = splitItem.quantity_pending
      }
    },

    fetchItems() {
      const warehouseId = this.filters.warehouse || null
      this.$nextTick(() => {

        const urlRoute = this.handoverList
          ? 'ajax.delivery-notes.get-handover-items'
          : this.itemsRoute
        this.$http.get(this.route(urlRoute, {
          note: this.note.id,
          warehouse: warehouseId,
        }))
          .then(resp => {
            this.form.actual.items = resp.data.data || [];
            this.otherWarehouses = resp.data.others || []
          })
      })
    },

    fetchVessels() {
      if (Array.isArray(this.boats) && this.boats.length) {
        return;
      }

      this.$http.get(this.route('ajax.boat-list'))
        .then(resp => {
          this.boats = resp.data
        })
    },
  },

  mounted() {
    this.fetchItems()
  }
}
</script>
